import type { NotificationsListResponse } from '@/entities/notification/model';
import { apiFetch } from '@/shared/api/apiClient';

interface UnreadCountResponse {
    unread_count?: number;
}

interface ListParams {
    page?: number;
    per_page?: number;
    unread?: boolean;
}

export async function fetchNotificationsList(params: ListParams = {}): Promise<NotificationsListResponse | null> {
    return apiFetch<NotificationsListResponse>(route('notifications.list'), {
        params: {
            page: params.page,
            per_page: params.per_page,
            unread: params.unread ? 1 : undefined,
        },
    });
}

export async function fetchUnreadNotificationsCount(): Promise<number | null> {
    const data = await apiFetch<UnreadCountResponse>(route('notifications.unread_count'));
    return typeof data?.unread_count === 'number' ? data.unread_count : null;
}

export async function markNotificationRead(id: string): Promise<number | null> {
    const data = await apiFetch<UnreadCountResponse>(route('notifications.read', { id }), {
        method: 'POST',
    });
    return typeof data?.unread_count === 'number' ? data.unread_count : null;
}

export async function markAllNotificationsRead(): Promise<number | null> {
    const data = await apiFetch<UnreadCountResponse>(route('notifications.read_all'), {
        method: 'POST',
    });
    return typeof data?.unread_count === 'number' ? data.unread_count : null;
}
